<template>
  <div>
    <div class="tent">
      <el-input
        class="searchInput"
        @keyup.enter="Search"
        v-model="val"
        placeholder="文章标题、作者、关键词、摘要"
        size="small"
      ></el-input>

      <el-button type="primary" plain @click="Search" class="search_button"
        >搜索</el-button
      >
      <el-button type="primary" plain @click="AdvancedSearch" class="highsearch"
        >高级检索</el-button
      >
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'search',
  data() {
    return {
      val: '',
    }
  },
  methods: {
    //简单搜索
    Search() {
      if (this.val == '') {
        alert('请填写检索内容')
      } else {
        this.$newOpen('/#/QuickSearch?isdatab=true')
        localStorage.setItem('value', this.val)
      }
    },
    //高级搜索
    AdvancedSearch() {
      this.$router.push('/AdvancedSearch?isdatab=true')
    },
  },
}
</script>

<style>
.searchInput .el-input__inner {
  border-radius: 0px !important;
  border: 1px #4a90e2 solid;
}
.searchInput .el-input__suffix {
  line-height: 35px;
  right: -20px !important;
}
.el-input--suffix .el-input__inner {
}
.search .searchInput .el-input__inner {
  box-sizing: content-box;
  padding-right: 15px;
  margin-right: 15px;
}
.search .el-input--small {
  padding-right: 8px;
}
.el-input--small .el-input__inner{
  height: 32px;
    line-height: 32px;
}
.search_button {
  display: inline-block;
  margin-top: 10px !important;
  background: #4a90e2 !important;
  color: #fff !important;
  width: 49% !important;
  height: 32px !important;
  line-height: 8px !important;
}
.quick_button span,
.quick_button a {
  margin-right: 5%;
}
@media (max-width: 1200px) {
  .searchInput {
    width: 55% !important;
  }
  .quick_button span,
  .quick_button a {
    margin-right: 4%;
  }
}
.highsearch {
  display: inline-block;
  margin-top: 10px !important;
  background: #fff !important;
  color: #4a90e2 !important;
  width: 48.9% !important;
  height: 32px !important;
  line-height: 8px !important;
}
/* .el-input__wrapper{
 box-shadow:none !important;
} */
.el-input--small .el-input__wrapper{
  padding:0 !important;
}
</style>
